import { TrendingUp } from "@material-ui/icons";
import { memo } from "react";

const { Typography, Grid } = require("@material-ui/core");
const {
  default: MaskService,
} = require("../../../../../utils/mask/maskService");

const GainTotalRow = ({ total, isFinal }) => {
  const spacing = isFinal ? 16 : 8;

  return (
    <Grid
      container
      item
      direction="row"
      style={{
        padding: spacing,
        gap: spacing,
        maxWidth: "100%",
        backgroundColor: "lightgreen",
      }}
    >
      <Grid item>
        <TrendingUp style={{ color: "green" }} fontSize="medium" />
      </Grid>
      <Grid item xs>
        <Typography
          style={{
            color: "green",
            fontWeight: "bold",
          }}
        >
          {isFinal ? "Resultado: " : "Lucro: "}
        </Typography>
      </Grid>
      <Grid item>
        <Typography
          style={{
            color: "green",
            fontWeight: "bold",
          }}
        >{`R$ ${MaskService.toMask(
          "decimal",
          parseFloat(total).toFixed(2),
          2
        )}`}</Typography>
      </Grid>
    </Grid>
  );
};

export default memo(GainTotalRow);
